<div class="content">
  <div fxLayout="row wrap" fxLayoutGap="16px grid">
  <div fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="33%" *ngFor="let show of Shows">
    <app-show-info [show]="show"></app-show-info>
  </div>
  </div>
</div>
